<template>
  <div>
    <!-- <img src="../assets/img/close.png" @click="vclose" class="vicon" v-if="vFlag" /> -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="box1" v-if="flag && !item.img">
        <img src="../assets/img/icon_fanhui.png" class="icon" @click="close" />

        <img class="avatar" :src="item.img" v-if="item.img" />

        <h1>{{ item.name }}</h1>

        <p>
          {{ item.msg }}
        </p>

        <div class="btn" v-if="item.url" @click="watch(item)">观看视频</div>
      </div>

      <div class="box1 box3" v-if="flag && item.img">
        <img src="../assets/img/icon_fanhui.png" class="icon" @click="close" />
        <img class="avatar" :src="item.img" v-if="item.img" />

        <h1>{{ item.name }}</h1>

        <p>
          {{ item.msg }}
        </p>

        <div class="btn" v-if="item.url" @click="watch(item)">观看视频</div>
      </div>

      <div class="box" v-if="flag1">
        <img src="../assets/img/icon_fanhui.png" class="icon" @click="close" />
        <el-carousel :interval="50000" arrow="always">
          <el-carousel-item v-for="(item, index) in groupList" :key="index">
            <img :src="item.img" class="avatar" />
            <div class="msgBox">
              <h1>{{ item.name }}</h1>
              <h3>{{ item.work }}</h3>
              <p>
                {{ item.msg }}
              </p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="box" v-if="flag2">
        <img src="../assets/img/icon_fanhui.png" class="icon" @click="close" />
        <img src="../assets/img/erweima.jpeg" class="avatar" />
        <div class="msgBox">
          <h1>联系我们</h1>
          <p>
            公司电话：010-86466560<br />
            邮箱：yycx@o2vr.net<br />
            北京研发中心:北京市海淀区永泰庄北路1号东升国际科学园1号楼A座3层<br />
            武汉研发中心:武汉市洪山区关山大道111号光谷时代广场A座803
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Bus from "../../common/js/bus";
export default {
  data() {
    return {
      vedioList: [
        [
          {
            name: "公司简介",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E5%85%AC%E5%8F%B8%E4%BB%8B%E7%BB%8D%E5%BC%B9%E5%B9%95%E8%A7%86%E9%A2%91.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001631932985&Signature=9s1ebZL%2FrkazUWfQETM4fNP9Dt8%3D",
            msg:
              "元一畅想科技是全球一流的WEB GL引擎技术和服务提供商。我们正在用高效流畅的真3D技术改造移动互联营销模式，及电商和教育视觉体验。致力于创造一个具备真实、畅达、高交互性的掌上（移动终端设备）元宇宙（Metaverse）和数字孪生（Digital twin）世界 。公司成立以来已经成功服务东易日盛集团、宝马中国、实地地产、茅台集团、国家电网、中国石油、航天三院、中国传媒大学、中央音乐学院等灯塔客户。",
          },
        ],
        [
          {
            name: "室内设计引擎",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E5%AE%B6%E5%B1%85-%E8%BD%AC%E6%A0%BC%E5%BC%8F.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=360001634016277&Signature=s4bR%2BcKgziLInAooh5bMXm3wM7U%3D",
            msg:
              "室内设计引擎，利用人工智能与增强现实算法，帮助装配式内装、家居和地产行业快速设计虚拟样板间，打通商家获客、内装设计与装修实施。",
          },
          {
            name: "木作参数引擎",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E6%9C%A8%E4%BD%9C%E5%8F%82%E6%95%B0%E7%BC%96%E8%BE%91%E5%99%A8.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=360001632987821&Signature=RgiaS1zN%2BzEaDVOk07sY4Mf7aeI%3D",
            msg:
              "木作参数引擎，几何驱动地参数化VR引擎，帮助家居厂商完成从设计到工厂的全链路数字化，极大提升设计生产效能和定制化能力。",
          },
          {
            name: "二维动态交互编辑器", //视频暂缺
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/ARAI%E6%9C%AA%E6%9D%A5%E5%AE%9E%E9%AA%8C%E5%AE%A4-WbGL%E5%BC%95%E6%93%8E.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=37631244573&Signature=9JzMHXxLM3AxWQ4RmVovHzrEzL4%3D",
            msg:
              "二维动态交互编辑器，快速创建二维高动态界面，整合VR/AR交互，适配多屏幕、多通道实时融合，支持裸眼3D、CAVE和特种分辨率显示设备。",
          },
          {
            name: "WebGL引擎",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/02web%E5%BC%95%E6%93%8E.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=3600001631943154&Signature=8mVvBzakhQhIkxWAOAZWUN75CQU%3D",
            msg:
              "WebGL引擎O2web，完全自主研发，结合了WebGL、HTML5、OpenGL/DirectX等技术，集数据采集、模型编辑、压缩发布、真实感实时线上展示等功能的全栈WebGL低代码解决方案。",
          },
        ],
        [
          {
            name: "VR智能桌面",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E7%A1%AC%E4%BB%B6%E4%BA%A4%E4%BA%92%E5%B1%95%E5%8E%85-VR%E6%99%BA%E8%83%BD%E6%A1%8C%E9%9D%A2.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001631255300&Signature=uwgfKOXHIk3yyZurXxRCsLWpVfg%3D",
            msg:
              "VR智能桌面，是元一畅想发明，利用令牌（MARKER）与手势结合的自然语言交互技术的双屏幕交互模式，融合展现虚拟现实和多媒体内容，营造逼真、形象、生动的展示效果。硬件主要包括了控制高精度的电容触摸屏和令牌（MARKER）控制器。",
          },
          {
            name: "AR沙盘",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E7%A1%AC%E4%BB%B6%E4%BA%A4%E4%BA%92%E5%B1%95%E5%8E%85-AR%E6%B2%99%E7%9B%98.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=3600001631269141&Signature=echr6ccaowdL32rZ7%2BYcttoEFEo%3D",
            msg:
              "AR沙盘，是元一畅想与苹果中国合作，开发的充分利用ipad等移动设备图形性能AR产品，通过激光扫描仪获取实体沙盘点云，AR沙盘可以在秒级时间中准确地1：1匹配沙盘所有细节，通过增强式的AR视觉表达，将三维互动的智慧城市、园区、工厂、商业、小区、户模赋予实体沙盘，为沙盘提供规划配套、工艺工法、隐蔽工程、智能化功能、天气物侯、春夏秋冬、潮起潮落等超现实场景呈现。",
          },

          {
            name: "VR头显",

            msg:
              "IPAD，在O2VR的交互生态中有重要的位置，既是VR内容表达端，也是虚拟场景漫游控制端，当然我们是苹果商业端合作伙伴（ABSP），有订购苹果全系列产品的需求，也欢迎联系我们。",
          },

          {
            name: "IPAD",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E7%A1%AC%E4%BB%B6%E4%BA%A4%E4%BA%92%E5%B1%95%E5%8E%85-ipad.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001631255549&Signature=wZwuj%2B7eA%2BI23nNKs%2FdvvvrcYYc%3D",
            msg:
              "IPAD，在O2VR的交互生态中有重要的位置，既是VR内容表达端，也是虚拟场景漫游控制端，当然我们是苹果商业端合作伙伴（ABSP），有订购苹果全系列产品的需求，也欢迎联系我们。",
          },
          {
            name: "手机",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E6%89%8B%E6%9C%BA-%E5%AE%9D%E9%A9%AC%E6%B8%B8%E6%88%8F.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=360001638758880&Signature=EZVHmeV3X%2FWZVh%2FvRuwFPRDTup4%3D",
            msg:
              "手机，普通的智能移动终端就可以加入到O2VR的AR/VR元宇宙空间，在5G的大背景下，我们推动AR/VR形式和内容的普惠，真正联接人和计算机。",
          },
          {
            name: "Surface studio",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E7%A1%AC%E4%BB%B6%E4%BA%A4%E4%BA%92%E5%B1%95%E5%8E%85-surfacestudio.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=360001631255422&Signature=tmOyM7f7f5CpENbWHuEurwUP9O4%3D",
            msg:
              "Surface studio，是元一畅想在微软的交互设备Surface studio上开发的系列充分利用电磁触摸屏和Dail（拨号盘）交互的VR内容，用Surface 的大屏幕控制可以精准地在虚拟空间中进行漫游、触发故事、并用Dail进行产品模型替换和颜色设计等。",
          },
        ],

        [
          {
            name: "军工",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E5%86%9B%E5%B7%A5-%E7%BA%A2%E8%93%9D%E5%AF%B9%E6%88%98AR%E6%B2%99%E7%9B%98.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001638752637&Signature=UUeClRYoDvwUjYvrn%2FfVPQo3JA8%3D",
            msg:
              "利用国产引擎O2Engine专利的双层编辑器，可以“所见即所得”地发布到Linux、麒麟、鸿蒙等系统上运行，实现PBR材质和全三维的交互。可与战场态势软件的数据接口进行整合，为红蓝数字对抗提供直观的虚拟沙盘界面。",
            img: require("../assets/img/jungong.jpg"),
          },
          {
            name: "教育",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E7%89%A9%E6%B5%81%E6%95%99%E8%82%B2.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001638757848&Signature=vTsOfPsKaRlNLCnUv%2B7cC05Uayo%3D",
            msg:
              "O2VR/AR全场景营销系统，能够为案场提供数字楼书、数字户模、AR沙盘、售楼宝等高度配合职业经纪人销讲演绎，拓客引流，跟进转化的全流程、全场景营销解决方案。线上异地双重引流，销售前置，内容一次制作，多场景复用。",
            img: require("../assets/img/jiaoyu.jpg"),
          },

          {
            name: "家装",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E8%A1%8C%E4%B8%9A%E6%95%99%E8%82%B2%E6%96%B9%E6%A1%88-%E5%AE%B6%E8%A3%85.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001631265406&Signature=yhIvNogvSVJ1rJwSYIZD8e4spzo%3D",
            msg:
              "家装：所见即所得地联结客户和智能生产线，物理参数武装的虚拟引擎，用严谨的脚本系统将工业文件，约束文件传递到家装设计引擎中，让引擎的产出是可生产可交付的。很好的支持装配式内装和工厂联结，实施导引等关键环节。",
            img: require("../assets/img/jiazhuang.png"),
          },
          {
            name: "数字孪生",
            url:
              "https://o2res.oss-cn-beijing.aliyuncs.com/webres/%E5%85%AC%E5%8F%B8%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91/%E6%95%B0%E5%AD%97%E5%AD%AA%E7%94%9F%E6%9C%80%E7%BB%88%E7%89%88.mp4?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36000001641435316&Signature=xb24Y491lnfzCMUelSHk13jYsGo%3D",
            msg:
              "基于国产引擎O2Engine研发的O2数字孪生基础软件编辑平台将O2Engine完全融合于3DGIS平台底层，加入工作管理流程编辑器的脚本应用系统、配合AI分析技术，实现了低宽带下的实时渲染、物理计算与事件仿真同时并行的独特行业优势。",
            img: require("../assets/img/shuzi.jpg"),
          },
        ],
      ],
      groupList: [
        {
          name: "谢浩",
          work: "CEO",
          img: require("../assets/img/a1.jpg"),
          msg:
            "CEO，中国传媒大学计算机动画硕士，长江商学院VCstar、ARM安创成长营学员。常年从事计算机图形产品开发、产品和营销工作。筹建并运营中国第一个规模化的云渲染中心。业界首倡“轻VR”概念，主导推出的“全息教室”产品年销售额超过1亿元。",
        },

        {
          name: "李欣",
          work: "董事长",
          img: require("../assets/img/a2.jpg"),
          msg: "基础技术开发者，中国第一个商用VR引擎的构架师",
        },

        {
          name: "吴明峰",
          work: "CTO",
          img: require("../assets/img/a3.jpg"),
          msg:
            "CTO 中国传媒大学计算机动画硕士，武汉大学计算机理学学士。常年从事计算机图形产品开发和项目管理工作。主导研发多款公司核心VR/AR产品线。管理实施了百余个项目，整体项目销售额超过5000万。",
        },

        {
          name: "李桢",
          work: "COO",
          img: require("../assets/img/a4.jpg"),
          msg:
            "COO，英国格拉斯哥大学 市场与客户行为学 硕士，美国Salesforce 销售管理认证。曾任职于ASSA ABLOY集团、深圳市披克科技有限公司全国营销总监、美国联合技术（UTC）集团，北京市集保保安消防工程有限公司总经理， HID Global中国区渠道经理。",
        },
        {
          name: "税琳琳",
          work: "首席设计官",
          img: require("../assets/img/a5.jpg"),
          msg:
            "博士，中国传媒大学设计思维学院院长，斯坦福访问学者，首次将斯坦福设计思维引入到科技产品设计中",
        },
      ],
      flag: false,
      flag1: false, //团队成员
      flag2: false, //联系我们
      item: "",
      vFlag: false,
    };
  },
  created() {
    Bus.$on("change", (x, y) => {
      console.log(x, y);
      if (x == "close") {
        this.close();
      } else if (x == "watch") {
        this.end();
        this.vFlag = true;
        //document.o2.stop_ctrl(1);
        document.o2.switch_camera(-12604, 2000, -5243, -9745, 2278, -5477);
      }
    });
    Bus.$on("item", (target) => {
      this.end();
      if (
        target[2].name == "军工" ||
        target[2].name == "家装" ||
        target[2].name == "教育" ||
        target[2].name == "数字孪生"
      ) {
        document.o2.active_solution(target[2].name);
      }
      if (target[2].name == "室内设计引擎") {
        document.o2.active_software("hot_software1");
      }
      if (target[2].name == "木作参数引擎") {
        document.o2.active_software("hot_software2");
      }
      if (target[2].name == "二维动态交互编辑器") {
        document.o2.active_software("hot_software3");
      }
      if (target[2].name == "webgl引擎") {
        document.o2.active_software("hot_software4");
      }

      if (target[0] == 0) {
        if (target[2].name == "公司介绍") {
          setTimeout(() => {
            this.flag = true;
          }, 20);

          this.item = this.vedioList[0][0];
        } else if (target[2].name == "团队成员") {
          setTimeout(() => {
            this.flag1 = true;
          }, 20);
        } else if (target[2].name == "联系我们") {
          setTimeout(() => {
            this.flag2 = true;
          }, 20);
        }
      } else {
        setTimeout(() => {
          this.flag = true;
        }, 20);
        this.item = this.vedioList[target[0]][target[1]];
      }
    });
    Bus.$on("boxClose", (target) => {
      if (target) {
        this.end();
      }
    });
    Bus.$on("vFlag1", (target) => {
      this.vFlag = false;
      //document.o2.stop_ctrl(1);
      if (target == 0) {
        //document.o2.switch_camera(-376, 2000, 5107, -566, 3687, 126);
      } else if (target == 1) {
        //document.o2.switch_camera(-11851, 2000, 5652, -9634, 2045, 3408);
      } else if (target == 2) {
        //document.o2.switch_camera(10809, 2000, 5274, 8792, 2188, 3245);
      } else if (target == 3) {
        //document.o2.switch_camera(-522, 2000, -7275, -499, 2188, -4327);
      }

      setTimeout(() => {
        this.vFlag = true;
      }, 2000);
    });

    Bus.$on("vFlag2", (target) => {
      this.vFlag = false;
      //document.o2.stop_ctrl(1);
      console.log(target);
      if (target == "公司介绍" || target == "团队成员" || target == "联系我们") {
        // document.o2.switch_camera(-376, 2000, 5107, -566, 3687, 126);
      } else if (
        target == "室内设计引擎" ||
        target == "木作参数引擎" ||
        target == "二维动态交互编辑器" ||
        target == "webgl引擎"
      ) {
        //document.o2.switch_camera(-11851, 2000, 5652, -9634, 2045, 3408);
      } else if (
        target == "智能桌面" ||
        target == "AR沙盘" ||
        target == "vr头盔" ||
        target == "IPAD" ||
        target == "手机" ||
        target == "SURFACE STUDIO"
      ) {
        //document.o2.switch_camera(9809, 2000, 4274, 8792, 2188, 3245);
      } else if (target == "军工" || target == "教育" || target == "家装") {
        //document.o2.switch_camera(-522, 2000, -5775, -499, 2188, -4327);
      }

      setTimeout(() => {
        this.vFlag = true;
      }, 2000);
    });

    // Bus.$on("onItemClick", (target) => {
    //   this.end();
    //   if (target == "公司介绍") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[0][0];
    //   } else if (target == "团队成员") {
    //     setTimeout(() => {
    //       this.flag1 = true;
    //     }, 20);
    //   } else if (target == "分享") {
    //     setTimeout(() => {
    //       this.flag2 = true;
    //     }, 20);
    //   } else if (target == "hot_software1") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[1][0];
    //   } else if (target == "hot_software2") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[1][1];
    //   } else if (target == "hot_software3") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[1][2];
    //   } else if (target == "hot_software4") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[1][3];
    //   } else if (target == "hot_software4") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[1][3];
    //   } else if (target == "surface003detachobj1") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[2][0];
    //   } else if (target == "default011") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[2][1];
    //   } else if (target == "vr头盔_019") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[2][2];
    //   } else if (target == "平板屏幕003") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[2][3];
    //   } else if (target == "平板屏幕003") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[2][3];
    //   } else if (target == "Box060") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[2][4];
    //   } else if (target == "对象002") {
    //     setTimeout(() => {
    //       this.flag = true;
    //     }, 20);

    //     this.item = this.vedioList[2][5];
    //   }
    // });
  },
  methods: {
    close() {
      this.flag = false;
      this.flag1 = false;
      this.flag2 = false;
      console.log(this.flag1);
      Bus.$emit("close", true);
      document.o2.on_close_lable();
      console.log("关闭");
      document.o2.adminClick("close", "");
    },
    end() {
      this.flag1 = false;
      this.flag = false;
      this.flag2 = false;
    },
    watch(e) {
      document.o2.adminClick("watch", JSON.stringify(e));
      this.end();
      this.vFlag = true;
      //document.o2.stop_ctrl(1);
      document.o2.switch_camera(-12604, 2000, -5243, -9745, 2278, -5477);
      if (document.o2) {
        document.o2.screen_url(e.url);
        // let o2 = document.o2;
        // let obj = o2.screen;
        // if (obj) {
        //   obj.visible = true;
        //   if (!this.bVideoPlay) {
        //     o2.videoTex = obj.material.map;
        //     obj.material.map = o2.get_video_tex(e.url, true);
        //     this.bVideoPlay = true;
        //   } else if (this.bVideoPlay && o2.videoTex) {
        //     obj.material.map = o2.videoTex;
        //     //o2.get_video_tex("",false);
        //     o2.stop_video_tex();
        //     this.bVideoPlay = false;
        //   }
        // }
      }
    },
    vclose() {
      console.log("关闭视频");
      document.o2.stop_ctrl(0);
      this.vFlag = false;
      this.end();
    },
  },
  watch: {
    // vFlag(val) {
    //   Bus.$emit("flag", val);
    // },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 615px;
  height: 250px;
  background: rgba($color: #fff, $alpha: 0.6);

  border-radius: 13px;
  position: absolute;
  top: 30px;
  right: 0;
  margin: auto;
  left: 0;
  transition: 0.5s;
  ::v-deep .el-carousel__container {
    height: 250px;
  }
  .icon {
    width: 25px;
    height: 25px;
    position: absolute;
    left: 20px;
    top: 27px;
    z-index: 999;
  }
  .avatar {
    width: 150px;
    height: 150px;
    border-radius: 10px;
    position: absolute;
    top: 56px;
    left: 64px;
  }
  .msgBox {
    top: 56px;
    position: absolute;
    left: 260px;
    text-align: left;
    h1 {
      font-size: 25px;
      font-family: SimHei;
      font-weight: bold;
      color: #ffa200;
      margin-bottom: 8px;
    }
    h3 {
      font-size: 16px;
      font-family: SimHei;
      font-weight: bold;
      color: #4b4b4b;
      margin-bottom: 11px;
    }
    p {
      width: 300px;
      font-size: 12px;
      font-family: SimHei;
      font-weight: 400;
      color: #000000;
      line-height: 16px;
    }
    p::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .btn {
      width: 80px;
      text-align: center;
      font-size: 14px;
      font-family: SimHei;
      font-weight: bold;
      color: #ffffff;
      background: #ffa200;
      margin-top: 15px;
      padding: 3px;
    }
  }
}
.vicon {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
  margin: auto;
}

.box1 {
  width: 615px;
  height: 220px;
  background: rgba($color: #fff, $alpha: 0.8);

  border-radius: 13px;
  position: absolute;
  top: 30px;
  right: 0;
  margin: auto;
  left: 0;
  transition: 0.5s;
  .icon {
    width: 25px;
    height: 25px;
    position: absolute;
    left: 20px;
    top: 27px;
    z-index: 999;
  }
  h1 {
    font-size: 25px;
    font-family: SimHei;
    font-weight: bold;
    color: #ffa200;
    text-align: center;
    margin-top: 27px;
  }
  p {
    margin: 10px 20px;
    font-size: 14px;
    font-family: SimHei;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
    text-align: left;
  }
  .btn {
    width: 80px;
    text-align: center;
    font-size: 14px;
    font-family: SimHei;
    font-weight: bold;
    color: #ffffff;
    background: #ffa200;
    margin-top: 20px;
    padding: 3px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 15px;
  }
}
.box3 {
  .avatar {
    width: 150px;
    height: 100px;
    border-radius: 10px;
    position: absolute;
    top: 68px;
    left: 20px;
  }
  p {
    margin: 10px 20px 10px 195px;
  }
}

@media screen and (max-width: 450px) {
  .box3 {
    p {
      width: 210px;
      margin-left: 175px !important;
      text-align: justify !important;
    }
  }
  .box1 {
    width: 100%;

    z-index: 999;
    height: 250px;
    .icon {
      width: 20px;
      height: 20px;
      position: absolute;
      left: 20px;
      top: 27px;
      z-index: 999;
    }
    h1 {
      font-size: 20px;
      font-family: SimHei;
      font-weight: bold;
      color: #ffa200;
      text-align: center;
      margin-top: 27px;
    }
    p {
      margin: 10px 20px;
      font-size: 12px;
      font-family: SimHei;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      text-align: left;
    }
  }

  .box {
    width: 100%;
    height: 200px;
    background: rgba($color: #fff, $alpha: 0.6);
    z-index: 1000;

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 10px;
      position: absolute;
      top: 56px;
      left: 62px;
    }
    .msgBox {
      top: 56px;
      position: absolute;
      left: 155px;

      text-align: left;
      p {
        width: 180px;
        font-size: 12px;
        font-family: SimHei;
        font-weight: 400;
        color: #000000;
        line-height: 16px;
        height: 50px;
        overflow-y: scroll;
      }

      p::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .btn {
        width: 80px;
        text-align: center;
        font-size: 14px;
        font-family: SimHei;
        font-weight: bold;
        color: #ffffff;
        background: #ffa200;
        margin-top: 15px;
        padding: 3px;
      }
    }
  }
}
</style>
